export default __webpack_public_path__ + "static/media/Group926.415bef60.svg";